import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { AvaliacaoAcaoContext } from "./AvaliacaoAcaoContext";
import NewQuestionarioSeplag from "./NewQuestionario";
import { Card } from "primereact/card";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const PercentageBlock = ({ width, className, percentage, label, isHighlighted, displayedPercentage }) => (
  <div style={{ width }}>
    <div className={className}>
      <p>{percentage}</p>
    </div>
    <div className="div-grafico-rodape">{label}</div>
    {isHighlighted && (
      <div>
        <i className="pi pi-arrow-up"></i>
        <label>
          {displayedPercentage.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </label>
      </div>
    )}
  </div>
);

PercentageBlock.propTypes = {
  width: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  displayedPercentage: PropTypes.number.isRequired,
};

const NewAnalisePPDCOFD = () => {
  const { setQuestAnaliseAtualizado, camposPPDCOFD, condicao, totalOrcamFinan, listaProduto } =
    useContext(AvaliacaoAcaoContext);
  const location = useLocation();

  const [calCei, setCalCei] = useState({ calSuperior: 0, calInferior: 0, result: 0 });
  const [highlightedPercentage, setHighlightedPercentage] = useState({
    isPerc40PrevistoInicial: false,
    isPerc60PrevistoInicial: false,
    isPerc80PrevistoInicial: false,
    isPerc90PrevistoInicial: false,
    isPerc110PrevistoInicial: false,
    isPerc120PrevistoInicial: false,
    isPerc140PrevistoInicial: false,
    isPerc160PrevistoInicial: false,
    isPerc161PrevistoInicial: false,
    porcentagemPrevistoInicial: 0,
    isPerc40PrevistoAtualizad: false,
    isPerc60PrevistoAtualizado: false,
    isPerc80PrevistoAtualizado: false,
    isPerc90PrevistoAtualizado: false,
    isPerc110PrevistoAtualizado: false,
    isPerc120PrevistoAtualizado: false,
    isPerc140PrevistoAtualizado: false,
    isPerc160PrevistoAtualizado: false,
    isPerc161PrevistoAtualizado: false,
    porcentagemPrevistoAtualizado: 0,
    isPerc40CEI: false,
    isPerc60CEI: false,
    isPerc80CEI: false,
    isPerc90CEI: false,
    isPerc110CEI: false,
    isPerc120CEI: false,
    isPerc140CEI: false,
    isPerc160CEI: false,
    isPerc161CEI: false,
    porcentagemCEI: 0.0,
  });

  const updateHighlightedPercentage = (key) => {
    setHighlightedPercentage((prevState) => ({
      ...prevState,
      [key]: true,
    }));
  };

  // Função para atualizar o estado de acordo com o valor de percPPD
  const reguaPPD = (percPPD) => {
    if (percPPD <= 40) {
      updateHighlightedPercentage("isPerc40PrevistoInicial");
    } else if (percPPD <= 60) {
      updateHighlightedPercentage("isPerc60PrevistoInicial");
    } else if (percPPD <= 80) {
      updateHighlightedPercentage("isPerc80PrevistoInicial");
    } else if (percPPD <= 90) {
      updateHighlightedPercentage("isPerc90PrevistoInicial");
    } else if (percPPD <= 110) {
      updateHighlightedPercentage("isPerc110PrevistoInicial");
    } else if (percPPD <= 120) {
      updateHighlightedPercentage("isPerc120PrevistoInicial");
    } else if (percPPD <= 140) {
      updateHighlightedPercentage("isPerc140PrevistoInicial");
    } else if (percPPD <= 160) {
      updateHighlightedPercentage("isPerc160PrevistoInicial");
    } else if (percPPD >= 160.001) {
      updateHighlightedPercentage("isPerc161PrevistoInicial");
    }
  };

  // Função para atualizar o estado de acordo com o valor de percCOFD
  const reguaCOFD = (percCOFD) => {
    if (percCOFD <= 40) {
      updateHighlightedPercentage("isPerc40PrevistoAtualizado");
    } else if (percCOFD <= 60) {
      updateHighlightedPercentage("isPerc60PrevistoAtualizado");
    } else if (percCOFD <= 80) {
      updateHighlightedPercentage("isPerc80PrevistoAtualizado");
    } else if (percCOFD <= 90) {
      updateHighlightedPercentage("isPerc90PrevistoAtualizado");
    } else if (percCOFD <= 110) {
      updateHighlightedPercentage("isPerc110PrevistoAtualizado");
    } else if (percCOFD <= 120) {
      updateHighlightedPercentage("isPerc120PrevistoAtualizado");
    } else if (percCOFD <= 140) {
      updateHighlightedPercentage("isPerc140PrevistoAtualizado");
    } else if (percCOFD <= 160) {
      updateHighlightedPercentage("isPerc160PrevistoAtualizado");
    } else if (percCOFD >= 160.001) {
      updateHighlightedPercentage("isPerc161PrevistoAtualizado");
    }
  };
  const reguaCEI = (percCEI) => {
    if (percCEI <= 40) {
      updateHighlightedPercentage("isPerc40CEI");
    } else if (percCEI <= 60) {
      updateHighlightedPercentage("isPerc60CEI");
    } else if (percCEI <= 80) {
      updateHighlightedPercentage("isPerc80CEI");
    } else if (percCEI <= 90) {
      updateHighlightedPercentage("isPerc90CEI");
    } else if (percCEI <= 110) {
      updateHighlightedPercentage("isPerc110CEI");
    } else if (percCEI <= 120) {
      updateHighlightedPercentage("isPerc120CEI");
    } else if (percCEI <= 140) {
      updateHighlightedPercentage("isPerc140CEI");
    } else if (percCEI <= 160) {
      updateHighlightedPercentage("isPerc160CEI");
    } else if (percCEI >= 160.001) {
      updateHighlightedPercentage("isPerc161CEI");
    }
  };
  const formatarData = (dataString) => {
    if (dataString !== null && dataString !== undefined) {
      const partes = dataString.split("/");
      const ano = parseInt(partes[2]);
      return ano;
    }
  };
  useEffect(() => {
    setHighlightedPercentage((prevState) => ({
      ...prevState,
      porcentagemPrevistoInicial: totalOrcamFinan.vlrPpd,
      porcentagemPrevistoAtualizado: totalOrcamFinan.vlrCofd,
    }));
    reguaPPD(totalOrcamFinan.vlrPpd);
    reguaCOFD(totalOrcamFinan.vlrCofd);

    if (
      totalOrcamFinan.vlrLiquidadoFinal

      // totalOrcamFinan.vlrMetaRealizada &&
      //totalOrcamFinan.vlrMetaAtualizada &&
      //  totalOrcamFinan.vlrLiquidado &&
      //  totalOrcamFinan.vlrAtualizado
    ) {
      let listaProdutors = [];
      listaProduto != null &&
        listaProduto.map((produto) => {
          let prod = { idView: null, previstoAtualizado: null, realizado: null, percRealizacao: null };
          prod.descElemento = produto.descElemento;
          prod.dataInicioPrevisto = produto.dataInicioPrevisto;
          prod.idView = produto.idView;
          prod.qtdeProdutoPrevisto = parseFloat(produto.qtdeProdutoPrevisto.toFixed(2));
          prod.qtdeRealizadoRAG = parseFloat(produto.qtdeRealizadoRAG.toFixed(2));
          prod.PercRealizadoPrevistoAtualizado = parseFloat(
            ((prod.qtdeRealizadoRAG / prod.qtdeProdutoPrevisto) * 100).toFixed(2)
          );
          listaProdutors.push(prod);
        });

      let mediaAnual24 = 0;
      let mediaAnual25 = 0;
      let mediaAnual26 = 0;
      let mediaAnual27 = 0;

      listaProdutors.map((produto) => {
        switch (formatarData(produto.dataInicioPrevisto)) {
          case 2024:
            mediaAnual24 += parseFloat(produto.PercRealizadoPrevistoAtualizado);
            break;
          case 2025:
            mediaAnual25 += produto.PercRealizadoPrevistoAtualizado;
            break;
          case 2026:
            mediaAnual26 += produto.PercRealizadoPrevistoAtualizado;
            break;
          case 2027:
            mediaAnual27 += produto.PercRealizadoPrevistoAtualizado;
            break;
        }
      });

      if (mediaAnual24 / listaProduto.length != 0 && totalOrcamFinan.vlrLiquidadoFinal !== 0) {
        setCalCei({
          calSuperior: (mediaAnual24 / listaProduto.length).toFixed(2),
          calInferior: totalOrcamFinan.vlrLiquidadoFinal,
          result: mediaAnual24 / listaProduto.length / totalOrcamFinan.vlrLiquidadoFinal,
        });
        reguaCEI(mediaAnual24 / listaProduto.length / totalOrcamFinan.vlrLiquidadoFinal);

        setHighlightedPercentage((prevState) => ({
          ...prevState,
          porcentagemCEI: mediaAnual24 / listaProduto.length / totalOrcamFinan.vlrLiquidadoFinal,
        }));

        return;
      }
      reguaCEI(0);
    } else {
      reguaCEI(0);
    }
  }, []);

  const renderizaPercentageBlock = (width, className, percentage, label, isHighlighted, displayedPercentage) => {
    if (displayedPercentage != undefined) {
      return (
        <PercentageBlock
          width={width}
          className={className}
          percentage={percentage}
          label={label}
          isHighlighted={isHighlighted}
          displayedPercentage={displayedPercentage}
        />
      );
    }
  };

  const ppd = () => {
    return (
      <div className="div-regua" style={{ paddingBottom: "2em" }}>
        <div className="div-titulo-grafico">
          <h3>PPD - Planejamento e Programação da Despesa</h3>
        </div>
        <div className="div-color">
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "0%  40,00%",
            "Altamente Deficiente",
            highlightedPercentage.isPerc40PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "40,00% 60,00%",
            "Deficiente",
            highlightedPercentage.isPerc60PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "60,01% 80,00%",
            "Regular",
            highlightedPercentage.isPerc80PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "80,01% 90,00%",
            "Bom",
            highlightedPercentage.isPerc90PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10.5%",
            "div-blue",
            "90,01% 110,00%",
            "Òtimo",
            highlightedPercentage.isPerc110PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "110,01% 120,00%",
            "Bom",
            highlightedPercentage.isPerc120PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "120,01% 140,00%",
            "Regular",
            highlightedPercentage.isPerc140PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "140,01% 160,00%",
            "Deficiente",
            highlightedPercentage.isPerc160PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "160,01%  +",
            "Altamente Deficiente",
            highlightedPercentage.isPerc161PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
        </div>
      </div>
    );
  };

  const cofd = () => {
    return (
      <div className="div-regua" style={{ paddingBottom: "2em" }}>
        <div className="div-titulo-grafico">
          <h3>COFD - CAPACIDADE OPERACIONAL FINANCEIRA DA DESPESA</h3>
        </div>
        <div className="div-color">
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "0% 40,00%",
            "Altamente Deficiente",
            highlightedPercentage.isPerc40PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "40,00% 60,00%",
            "Deficiente",
            highlightedPercentage.isPerc60PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "60,01% 80,00%",
            "Regular",
            highlightedPercentage.isPerc80PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "80,01% 90,00%",
            "Bom",
            highlightedPercentage.isPerc90PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10.5%",
            "div-blue",
            "90,01% 110,00%",
            "Ótimo",
            highlightedPercentage.isPerc110PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "110,01% 120,00%",
            "Bom",
            highlightedPercentage.isPerc120PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "120,01% 140,00%",
            "Regular",
            highlightedPercentage.isPerc140PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "140,01% 160,00%",
            "Deficiente",
            highlightedPercentage.isPerc160PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "160,01%   +",
            "Altamente Deficiente",
            highlightedPercentage.isPerc161PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
        </div>
      </div>
    );
  };

  const cei = () => {
    return (
      <div className="div-regua">
        <div className="div-titulo-grafico">
          <h3>CEI - COEFICIENTE DE EFICIÊNCIA INDIVIDUAL</h3>
        </div>
        <div className="div-color">
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "0% 40,00%",
            "Altamente Deficiente",
            highlightedPercentage.isPerc40CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "40,01% 60,00%",
            "Deficiente",
            highlightedPercentage.isPerc60CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "60,01% 80,00%",
            "Regular",
            highlightedPercentage.isPerc80CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "80,01% 90,00%",
            "Bom",
            highlightedPercentage.isPerc90CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10.5%",
            "div-blue",
            "90,01% 110,00%",
            "Ótimo",
            highlightedPercentage.isPerc110CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-green",
            "110,01% 120,00%",
            "Bom",
            highlightedPercentage.isPerc120CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-yellow",
            "120,01%    140,00%",
            "Regular",
            highlightedPercentage.isPerc140CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-orange",
            "140,01% 160,00%",
            "Deficiente",
            highlightedPercentage.isPerc160CEI,
            highlightedPercentage.porcentagemCEI
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "160,01% +",
            "Altamente Deficiente",
            highlightedPercentage.isPerc161CEI,
            highlightedPercentage.porcentagemCEI
          )}
        </div>
        <div style={{ display: "flex", flexDirection: "column", padding: "1em" }}>
          <span className="sub-title"> CEI - Coeficiente de Eficiência Individual</span>
          <span className="sub-title">(Relação de eficácia da execução física com a eficiência do gasto)</span>
        </div>

        {/* Quadro com borda */}
        <div className="cei-container">
          <div className="cei-calculo-container">
            <div className="cei-calculo-quadro">
              <div className="cei-calculo-retangulo">
                <strong>CEI=</strong>
              </div>
              <div className="cei-calculo-retangulo">
                <div className="cei-calculo-info">
                  <div className="cei-calculo-text">(meta física realizada) / (previsão da meta física atualizada)</div>
                  <div className="linha-divisao"></div>
                  <div className="cei-calculo-text">(valor liquidado) / (dotação atualizada)</div>
                </div>
              </div>
              <div className="cei-calculo-retangulo">
                <strong>x100</strong>
              </div>
            </div>
          </div>

          <div className="cei-calculo-result">
            <div className="cei-calculo-quadro">
              <div className="cei-calculo-retangulo">
                <strong>CEI=</strong>
              </div>
              <div className="cei-calculo-retangulo">
                <div className="cei-calculo-info">
                  <div className="cei-calculo-text">
                    {Number(calCei.calSuperior).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    %
                  </div>
                  <div className="linha-divisao"></div>
                  <div className="cei-calculo-text">
                    {Number(calCei.calInferior).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    %
                  </div>
                </div>
              </div>
              <div className="cei-calculo-retangulo">
                <strong>
                  = &nbsp;
                  {Number(calCei.result).toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  %
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Card>
      <NewQuestionarioSeplag
        campos={camposPPDCOFD}
        setCampos={setQuestAnaliseAtualizado}
        condicao={condicao}
        IsMaximoCaracteres={true}
        qtdMaxCaracteres={10000}
        isDisabled={!location.state.podeAvaliarAcao}
        renderPPD={ppd}
        renderCOFD={cofd}
        renderCEI={cei}
      />
    </Card>
  );
};

// Definição de PropTypes para validação das props
NewAnalisePPDCOFD.propTypes = {
  porcentagemPrevistoInicial: PropTypes.number.isRequired,
  podeAvaliarAcao: PropTypes.bool.isRequired,
  condicao: PropTypes.string,
  camposPPDCOFD: PropTypes.array.isRequired,
  questionarioPPDCOFD: PropTypes.string.isRequired,
  questionarioDispFinan: PropTypes.string.isRequired,
  questionarioEficiencia: PropTypes.string.isRequired,
};

export default NewAnalisePPDCOFD;
